import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSundryItems, clearUpdatedSundryItem, deleteSundryItem, clearDeletedSundryItem } from '../../../store/actions/sundriesActions'
import EmptyState from '../../elements/EmptyState'
import Pagination from '../../elements/Pagination'
import Loader from '../../elements/Loader'
import PencilSquareIcon from '../../elements/icons/PencilSquareIcon';
import ModalDialog from '../../layouts/ModalDialog';
import EditSundryItem from './EditSundryItem';
import TrashIcon from '../../elements/icons/TrashIcon';

const SundryItems = ({creatingSundryItem, setCreatingSundryItem}) => {
  const dispatch = useDispatch()
  const sundriesSelector = useSelector(state => state.sundries)

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);

  useEffect(() => {
    dispatch(fetchSundryItems('', page, perPage))

    if(sundriesSelector?.updatedSundryItem !== null){
      closeSundryItem()
      dispatch(clearUpdatedSundryItem())
    }

    if(sundriesSelector?.deletedSundryItem !== null){
      dispatch(clearDeletedSundryItem())
    }
    return () => {
      
    };
  }, [dispatch, page, perPage, sundriesSelector?.updatedSundryItem, sundriesSelector?.deletedSundryItem]);


  const [activeSundryItem, setActiveSundryItem] = useState(null);
  const [editingSundryItem, setEditingSundryItem] = useState(false);

  const openSundryItem = (item) => {
    setActiveSundryItem(item)
    setTimeout(()=>{
      setEditingSundryItem(true)
    }, 200)
  }

  const closeSundryItem = () => {
    setEditingSundryItem(false)
    setTimeout(()=>{
      setActiveSundryItem(null)
    }, 200)
  }

  const deleteItem = (itemId) => {
    if(window.confirm('Are you sure you want to delete this sundry item?')) {
      // Dispatch delete action here
      dispatch(deleteSundryItem(itemId))
    }
  }

  return (
    <>
      {sundriesSelector.loadingSundryItems && <Loader />}
      {sundriesSelector.sundryItems?.items?.length === 0 ? 
        <div className='w-full'>
          <EmptyState emptyStateText={`No sundry items found.`} />
        </div>
        :
        <div className='w-full'>
          <div className='grid grid-cols-3 gap-[10px] mt-[20px]'>
            {sundriesSelector?.sundryItems?.items?.map((sundryItem, index) => (
              <div key={index} className='w-full bg-white bg-opacity-50 rounded p-[20px] relative'>
                <div className='absolute top-[10px] right-[10px] flex flex-row-reverse items-center gap-x-2'>
                  <button onClick={()=>{deleteItem(sundryItem._id)}} className='text-sm text-vcm-purple underline'><TrashIcon className="w-4 h-4" /></button>
                  <button onClick={()=>{openSundryItem(sundryItem)}} className='text-sm text-vcm-purple underline'><PencilSquareIcon className="w-4 h-4" /></button>
                </div>
                <h3 className='font-[500] mb-[5px]'>{sundryItem.itemName}</h3>
                <p className='text-sm mb-[10px]'>{sundryItem.description?.substr(0,120)}{sundryItem.description?.length > 120 && '...'}</p>
                <div className='flex items-center justify-between'>
                  <span className={`inline-block text-xs px-2 py-1 rounded 
                      ${sundryItem.amountType === 'fixed' && 'bg-blue-600 text-blue-800 bg-opacity-10 font-outfit capitalize'}
                      ${sundryItem.amountType === 'variable' && 'bg-purple-600 text-purple-800 bg-opacity-10 font-outfit capitalize'}
                      `}>{sundryItem.amountType} amount</span>
                  {sundryItem.amount && sundryItem.amountType === 'fixed' && <h3>₦{sundryItem.amount.toLocaleString()}</h3>}
                </div>
              </div>
            ))}
          </div>
          <div className=''>
            <Pagination
              pagination={{
                currentPage: page,
                perPage: perPage,
                totalItems: sundriesSelector.sundryItems?.total,
              }}
              changePage={(page)=>{setPage(page)}}
              updatePerPage={(perPage)=>{setPerPage(perPage)}}
            />
          </div>
        </div>
      }


      {activeSundryItem && <ModalDialog
        shown={editingSundryItem} 
        closeFunction={()=>{closeSundryItem()}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Edit sundry item`}
        dialogTitle={`Edit sundry item - ${activeSundryItem?.name}`}
        maxWidthClass='max-w-md'
        hideActions={true}
      >
        <EditSundryItem 
          closeFunction={()=>{closeSundryItem()}} 
          item={activeSundryItem}
        />
      </ModalDialog>}
    </>
    
  )
}

export default SundryItems